import React from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Common_Images_Transport from '../../../common/common_imges_transport/Common_Images_Transport';
import { IMG_BASE_URL } from '../../../../config/Config';
import ReactImageGallery from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css';


const Astrologer_Gallery_Profile = ({ data }) => {
    const astro_detail = data?.astrolist
    const astro_details_list_slider = data?.astrolist?.profile_images || [];

    const slidesToShow = astro_details_list_slider?.length < 4 ? astro_details_list_slider?.length : 4;

    const settings = {
        infinite: astro_details_list_slider?.length > 1,
        speed: 500,
        slidesToShow: slidesToShow,
        slidesToScroll: 1,
        loop: false,
        autoplay: astro_details_list_slider?.length > 1,
        autoplaySpeed: 2000,
        arrows: astro_details_list_slider?.length > 1,
        variableWidth: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: astro_details_list_slider?.length < 4 ? astro_details_list_slider?.length : 4,
                    variableWidth: false,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: astro_details_list_slider?.length < 3 ? astro_details_list_slider?.length : 3,
                    variableWidth: false,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    variableWidth: false,
                },
            },
        ],
    };


    const images = astro_details_list_slider.map((img) => ({
        original: `${IMG_BASE_URL}${img?.image_file}`,
        thumbnail: `${IMG_BASE_URL}${img?.image_file}`,
    }));
    const [zoomImageIndex, setZoomImageIndex] = React.useState(null);

    const handleImageClick = (index) => {
        setZoomImageIndex(index);
    };
    // Function to close the zoom modal
    const closeZoomModal = () => {
        setZoomImageIndex(null);
    };




    return (
        <div>
            {astro_details_list_slider.length > 0 ? (
                <div className="aboutinfo border-t border-[#eee] mt-4 pt-4">
                    <h2 className="text-gray-900 text-lg font-semibold">
                        Gallery
                    </h2>
                    <div className="w-full">
                        <div className="astrologer_gallery z-0">
                            <Slider {...settings}>
                                {astro_details_list_slider.map((astro_details_list_slider_result, index) => (
                                    <div key={index} className="astro_gallery ">
                                        <img
                                            src={`${IMG_BASE_URL}${astro_details_list_slider_result?.image_file}`}
                                            className="w-full max-w-[250px] h-[250px] rounded cursor-pointer object-cover mx-auto"
                                            alt={`${astro_detail.name}`}
                                            onClick={() => handleImageClick(index)}
                                        />
                                    </div>
                                ))}
                            </Slider>
                        </div>
                    </div>

                    {/* Zoom Modal */}
                    {zoomImageIndex !== null && (
                        <div
                            className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-75 flex items-center justify-center z-50"
                            onClick={closeZoomModal}
                        >
                            <div onClick={(e) => e.stopPropagation()} className="relative max-w-xl w-full  p-4 rounded">
                                <ReactImageGallery
                                    items={images}
                                    startIndex={zoomImageIndex}
                                    showThumbnails={images?.length > 1 ? true : false}
                                    showFullscreenButton={false}
                                    showPlayButton={false}
                                    renderItem={(item) => (
                                        <img
                                            src={item.original}
                                            alt={item.originalAlt || ''}
                                            className="w-full max-w-[600px]  h-[400px] rounded cursor-pointer object-contain"
                                        />
                                    )}

                                />
                                <button
                                    className="absolute top-2 right-2 text-white bg-red-500 w-10 h-10 rounded-full"
                                    onClick={closeZoomModal}
                                >
                                    ✕
                                </button>
                            </div>
                        </div>
                    )}
                    {/* {zoomImage && (
                        // <div
                        //     className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-75 flex items-center justify-center z-50"
                        //     onClick={closeZoomModal}
                        // >
                        //     <div className="relative">
                        //         <Slider {...modalsliderSettings}>
                        //             <img src={zoomImage} alt="Zoomed" className="w-full h-auto max-h-[350px] rounded object-contain" />
                        //             <img src={zoomImage} alt="Zoomed" className="w-full h-auto max-h-[350px] rounded object-contain" />
                        //             <img src={zoomImage} alt="Zoomed" className="w-full h-auto max-h-[350px] rounded object-contain" />
                        //             <img src={zoomImage} alt="Zoomed" className="w-full h-auto max-h-[350px] rounded object-contain" />

                        //         </Slider>
                        //         <button className="absolute top-2 right-2 text-white bg-red-500 p-2 rounded-full" onClick={closeZoomModal}>
                        //             ✕
                        //         </button>
                        //     </div>
                        // </div>
                        <div
                            className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-75 flex items-center justify-center z-50"
                            onClick={closeZoomModal}
                        >
                            <ReactImageGallery items={images}
                                startIndex={images.id}
                                showThumbnails={true}
                                showFullscreenButton={true}
                                showPlayButton={false}
                            />
                            <button className="absolute top-2 right-2 text-white bg-red-500 p-2 rounded-full" onClick={closeZoomModal}>
                                ✕
                            </button>
                        </div>
                    )} */}
                </div>
            ) : (
                <p className="text-center text-gray-500">No images available</p>
            )}
        </div>
    );
};

export default Astrologer_Gallery_Profile;
